// aboutUsSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { get, ref,  } from 'firebase/database';
 import { db,   } from '../common/firebase';

 
export const fetchAboutUs = createAsyncThunk('aboutUs/fetchAboutUs', async () => {
    const aboutRef = ref(db, 'aboutUs');
    const snapshot = await get(aboutRef);
    const about = snapshot.val() || {};
    return Object.keys(about).map(key => ({ 
        id: key, 
        ...about[key],
        createdAt: Date.now(), 
        lastUpdated: Number(about[key].lastUpdated) || Date.now()
    }));
});
 
const aboutUsSlice = createSlice({
    name: 'aboutUs',
    initialState: {
        aboutUs: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAboutUs.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchAboutUs.fulfilled, (state, action) => {
                state.loading = false;
                state.aboutUs = action.payload;
            })
            .addCase(fetchAboutUs.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
        
    },
});

export default aboutUsSlice.reducer;
